exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden.v-btn[data-v-357aa604]{visibility:hidden;opacity:0}.v-btn[data-v-357aa604]{color:#fff;border-radius:5px;font-size:12px;-webkit-transition:opacity .5;transition:opacity .5}.v-icon[data-v-357aa604]{margin-right:5px}", ""]);

// exports
